// extracted by mini-css-extract-plugin
export const carmoLogo = "index-module--carmo-logo--3DQDo";
export const navbarBrandHelper = "index-module--navbarBrandHelper--3TbbJ";
export const navbarItemHelper = "index-module--navbarItemHelper--2qdBr";
export const headerTest = "index-module--header-test--ycblL";
export const headerShadow = "index-module--header-shadow--2H5ny";